import {Swiper, SwiperRef, SwiperSlide} from 'swiper/react';
import {Autoplay} from 'swiper/modules';
import 'swiper/css/pagination';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import React, {useCallback} from 'react';
import {Image} from 'antd-mobile';
import {BannerListItem} from '../home.type';
import {getBannerList} from '../home.service';
import {goToUrl} from '@/common-pages/game-navigate';
// import styles from './home.module.scss';
import {useResponsiveDimensions} from '@/utils';
import styles from './home.module.scss';
import {useFocusEffect} from '@react-navigation/native';

export interface HomeBannerProps {
  version?: number;
}

const getButtonText = (type: number) => {
  switch (type) {
    case 1:
      return 'Get Now';
    case 2:
      return 'Play Now';
    case 3:
      return 'Join Now';
    default:
      return '';
  }
};

const HomeBannerV2: React.FC<HomeBannerProps> = ({version}) => {
  const [bannerList, setbannerList] = React.useState<BannerListItem[]>([]);
  React.useEffect(() => {
    getBannerList(2).then(banner => {
      setbannerList(banner);
    });
  }, [version]);
  const {calcActualSize} = useScreenSize();
  const {width: screenWidth} = useResponsiveDimensions();
  // console.log('screenWidth', screenWidth);
  const ref = React.useRef<SwiperRef>(null);
  useFocusEffect(
    useCallback(() => {
      // console.log('>>>>>', ref.current);
      if (ref.current) {
        ref.current.swiper?.autoplay.start();
      }
      return () => {
        if (ref.current) {
          ref.current.swiper?.autoplay.stop();
        }
      };
    }, []),
  );

  // If only one banner, don't use Swiper
  // if (bannerList.length === 1) {
  //   const item = bannerList[0];
  //   return (
  //     <div
  //       className="w-full px-3"
  //       onClick={() => goToUrl(item.skipLinks, item.title)}>
  //       <div className="relative">
  //         <Image
  //           className="size-full rounded-lg h-[9.0625rem]"
  //           fallback={<div className="size-full bg-image" />}
  //           src={item.bannerImg}
  //         />
  //         {item.displayButtonType > 0 && (
  //           <div className="absolute bottom-3 right-3">
  //             <button className="px-4 py-2 bg-primary text-white rounded-full text-sm">
  //               {getButtonText(item.displayButtonType)}
  //             </button>
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <Swiper
      ref={ref}
      slidesPerView="auto"
      spaceBetween={calcActualSize(8)}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={bannerList?.length > 1}
      watchSlidesProgress={true}
      className="w-full pr-3"
      modules={[Autoplay]}>
      {bannerList?.map(item => (
        <SwiperSlide
          style={{
            width: `${(screenWidth * 280) / 375}px`,
          }}
          className={styles.home_banner_swiper_slide}
          key={item.bannerImg}
          onClick={() => {
            if (item.skipLinks) {
              goToUrl(item.skipLinks, item.title);
            }
          }}>
          <div className="relative">
            {/* rounded-lg */}
            <Image
              className={`${styles.home_banner_img}`}
              fallback={<div className="size-full bg-image" />}
              width={(screenWidth * 280) / 375}
              // height={152}
              src={item.bannerImg}
            />
            {item.displayButtonType > 0 && (
              <div className="absolute bottom-3 left-3 flex items-center ">
                <button className={styles.home_banner_btn}>
                  {getButtonText(item.displayButtonType)}
                </button>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HomeBannerV2;
